import { Trans, useTranslation } from 'react-i18next'

import BucketSizesBox from './BucketSizesBox'
import BallQuantityOfferingForm from './BallQuantityOfferingForm'
import BallDispenseFlowForm from './BallDispenseFlowForm'
import { useMemo } from 'react'

const BucketSizes = () => {
  const { t } = useTranslation()

  const hintContent = useMemo(
    () => (
      <>
        <Trans
          i18nKey={t('sentences.dispenseFlowHint')}
          components={{ strong: <strong />, br: <br /> }}
        />
        <div className="bg-background-mono-lighter border-border-stroke-pale text-text-dark mt-4 rounded-sm border p-4">
          <Trans
            i18nKey={t('sentences.dispenseFlowHintTip')}
            components={{ span: <span className="font-medium uppercase" />, br: <br /> }}
          />
        </div>
      </>
    ),
    [t]
  )

  return (
    <div className="text-content-base text-text-dark mb-2 flex flex-col gap-6">
      <span className="font-bold">{t('sentences.offeringAndDispenseFlow')}</span>
      <BucketSizesBox
        title={t('sentences.ballQuantityOffering')}
        description={t('sentences.ballQuantityOfferingText')}
        children={<BallQuantityOfferingForm />}
      />
      <BucketSizesBox
        title={t('sentences.dispenseFlow')}
        description={t('sentences.dispenseFlowText')}
        hint={hintContent}
        children={<BallDispenseFlowForm />}
      />
    </div>
  )
}

export default BucketSizes
